import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=e1294f20&scoped=true&"
import script from "./QuestionAnswer.vue?vue&type=script&lang=ts&"
export * from "./QuestionAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=e1294f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1294f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
